// Hide showing flag mode until it's actually used to modulate logic.
export const SHOULD_SHOW_SERVING_METHOD = false;

export enum FEATURE_FLAG_VARIANTS {
  Disabled = `disabled`,
  Enabled = `enabled`,
  Treatment = `treatment`,
}

// Variant validation constants
// If updating this, the limits enforced by the backend also need to be updated in ~/analytics/webapp/app_api/projects/feature_flags/__types__/feature_flag.py
export const MIN_VARIANTS = 2;
export const MAX_VARIANTS = 10;
export const MAX_PAYLOAD_BYTES = 32768; // 32 KB

export const FULLY_ROLLED_OUT = 1; // 100%

// Variant validation error types
export enum VariantError {
  NOT_ENOUGH_VARIANTS = `NOT_ENOUGH_VARIANTS`,
  TOO_MANY_VARIANTS = `TOO_MANY_VARIANTS`,
  INVALID_SPLIT = `INVALID_SPLIT`,
  MISSING_KEY = `MISSING_KEY`,
  DUPLICATE_KEY = `DUPLICATE_KEY`,
  INVALID_PAYLOAD = `PAYLOAD_NOT_JSON`,
  PAYLOAD_TOO_LONG = `PAYLOAD_TOO_LONG`,
}

// Rollout validation error types
export enum RolloutError {
  SPLITS_NOT_100 = `SPLITS_NOT_100`,
  INVALID_RUNTIME_RULE = `INVALID_RUNTIME_RULE`,
  MISSING_EVENT = `MISSING_EVENT`,
}

export enum FlagType {
  FEATURE_GATE = `FEATURE_GATE`,
  DYNAMIC_CONFIG = `DYNAMIC_CONFIG`,
  EXPERIMENT = `EXPERIMENT`,
}

export enum FlagStatus {
  DRAFT = `draft`,
  DISABLED = `disabled`,
  ENABLED = `enabled`,
  ARCHIVED = `archived`,
}
